import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { SocialProofSection } from '../components/SocialProofSection';
import { DiagnosticoSection } from '../components/DiagnosticoSection';
import { ProcessSection } from '../components/ProcessSection';
import { CuraSection } from '../components/CuraSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FAQSection } from '../components/FAQSection';
import { ContactFormSection } from '../components/ContactFormSection';
import { CTAFinal } from '../components/CTAFinal';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <main className="min-h-screen bg-pure-black text-white selection:bg-electric-yellow selection:text-black" data-id="element-301">
      <HeroSection data-id="element-302" />
      <SocialProofSection data-id="element-303" />
      <DiagnosticoSection data-id="element-304" />
      <ProcessSection data-id="element-305" />
      <CuraSection data-id="element-306" />
      <GuaranteeSection data-id="element-307" />
      <FAQSection data-id="element-308" />
      <ContactFormSection data-id="element-309" />
      <CTAFinal data-id="element-310" />
      <Footer data-id="element-311" />
    </main>;
}